import latinizedMap from '../constants/latinized-map';

const latinizeString = (str) => [...str].map((char) => latinizedMap[char] || char).join('');

export default latinizeString;
